import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBatteryMedium: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="battery-medium, power"><path d="M6 9.75V14.25M10.5 9.75V14.25M1.75 5.75H19.25V18.25H1.75V5.75ZM19.25 8.75H22.25V15.25H19.25V8.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBatteryMedium;
